<template>
    <Modal :open="displayModal" @close="displayModal = false">
        <div class="w-full bg-white shadow-lg rounded-none md:rounded-lg p-6" @click.self="displayModal = false">

            <div class="w-full relative">
                <h2 class="font-semibold text-gray-900 text-2xl leading-tight border-b-2 border-gray-200 pb-4">Edit Video Details</h2>
                <button class="text-grey-darkest font-bold rounded absolute top-0 right-0 outline-none text-xl absolute" @click="displayModal = false">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="mt-4">

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2" for="title">
                        Title
                    </label>
                    <input class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" id="title" type="text" v-model="data.title">
                </div>

                <div class="mb-4">
                    <label class="block text-grey-darkest font-bold mb-2">
                        Description
                    </label>
                    <textarea class="bg-grey-lighter appearance-none border-2 border-grey-lighter rounded w-full py-2 px-4 text-grey-darker leading-tight focus:outline-none focus:bg-white focus:border-grey-darkest" v-model="data.description" rows="10"></textarea>
                </div>

            </div>

            <!-- footer -->
            <div class="mt-10 clearfix">
                <button v-on:click="displayModal = false" class="px-4 py-2 text-gray-800 font-semibold bg-white hover:bg-gray-100 border rounded focus:outline-none focus:shadow-outline float-left">
                    Cancel
                </button>
                <button v-on:click="updateVideo" class="px-4 py-2 text-white font-semibold bg-blue-700 hover:bg-blue-800 border border-transparent rounded focus:outline-none focus:shadow-outline float-right">
                    Update Video
                </button>
            </div>

        </div>
        
    </Modal>
</template>

<script>
    import { EventBus } from '@/utils/events'
    import * as Config from '@/config'
    import { mapState, mapGetters } from 'vuex'

    import Modal from '@/components/Modal'

    export default {
        data() {
            return {
                displayModal: false,
                data: {},
            }
        },

        components: {
            Modal
        },

        mounted() {
            this.$nextTick(function () {
                EventBus.$on('stringer-edit-video-open-modal', this.open);
            }.bind(this));

            $(this.$refs.vuemodal).on("hidden.bs.modal", this.stopPlayerOnModalClose)
        },

        destroyed() {
            EventBus.$off('stringer-edit-video-open-modal', this.open);
        },

        methods: {
             ...mapGetters([
                'getAuthorizationHeader',
            ]),

            close() {
                // this.players[0].destroy();
            },

            open(data) {
                this.displayModal = true
                this.data = data
            },

            updateVideo() {

                var data = {
                    id: this.data.id,
                    title: this.data.title,
                    description: this.data.description,
                }

                var _this = this
                this.$http.post(Config.apiPath + "/api/v2/admin/videos/edit/" + this.data.id, data, this.getAuthorizationHeader()).then((response) => {
                    if(response.status == 200) {

                        EventBus.$emit('stringer-edit-video-refresh-data');
                        _this.displayModal = false

                    }
                });
                

            },

        }
        
    }
</script>

<style>
    .video-preview {
        text-align: center;
        color: #495057;
    }
</style>